import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
  selector: 'app-nuestra-facultad-principal',
  standalone: true,
  imports: [CommonModule,SanitizeHtmlPipe],
  templateUrl: './nuestra-facultad-principal.component.html',
  styleUrl: './nuestra-facultad-principal.component.scss'
})
export class NuestraFacultadPrincipalComponent implements OnChanges {
   @Input() info: any;
     svgContent: SafeHtml | null = null;
     searhSvg = true;
     icon=''
   
  isExpanded: boolean = false;
  @ViewChild('columnTexto') columnTexto!: ElementRef;
  private viewInitialized = false;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['info'] && this.viewInitialized) {
      this.loadSvg();
    }
  }
   
  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded == false && this.columnTexto) {
      this.columnTexto.nativeElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }
  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.loadSvg();
  }
 
  loadSvg(): void {
    const icon = this.info?.venue?.icono;
    this.icon = typeof icon === 'string' ? icon.trim() : '';

    if (!this.icon) {
      this.svgContent = null;
      return;
    }

    this.http.get(this.icon, { responseType: 'text' }).subscribe(svg => {
      const modifiedSvg = this.changeSvgColor(svg, '#ffffff');
      this.svgContent = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml,' + encodeURIComponent(modifiedSvg));
    });
  }

  changeSvgColor(svg: string, color: string): string {
    return svg.replace(/fill: #[0-9a-fA-F]{6};/g, `fill: ${color};`);
  }
   
   
}
